export default "__VITE_ASSET__BKtxInX4__"